import { ChangeEvent, useContext, useEffect, useState } from 'react'
import { JobListContext, JobStateFilters } from '@/context/jobListContext'

interface iProps {
  name: keyof JobStateFilters
  options: {
    value: string
    label: string
  }[]
  onChange: (value: string, key: string) => void
  value: string | null | undefined
  className?: string
}

const Radio = ({ name, options, onChange, value, className }: iProps) => {
  const [selected, setSelected] = useState(value)
  const { state } = useContext(JobListContext)
  const filters: JobStateFilters | null = state.filters ? state.filters : null

  const handleRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value, name)
  }

  useEffect(() => {
    if (filters && filters.hasOwnProperty(name)) {
      setSelected(filters[name] as string)
    }
  }, [state])

  return (
    <div className={className}>
      <style jsx>{`
        .radioInput:checked + .radioTitle {
          background: #000;
          color: #fff;
          border-color: #000;
        }

        .radioInput:disabled + .radioTitle {
          opacity: 0.5;
        }
      `}</style>
      <fieldset>
        {options.map((item, index) => (
          <label key={index} className='relative mr-2'>
            <input
              type='radio'
              onChange={handleRadioChange}
              value={item.value}
              checked={selected === item.value}
              name={name}
              className='absolute hidden radioInput'
            />
            <span className='inline-block border border-gray-100 hover:bg-gray-100 rounded-full py-1 md:py-3 px-5 mb-2 cursor-pointer radioTitle transition-colors'>
              {item.label}
            </span>
          </label>
        ))}
      </fieldset>
    </div>
  )
}

export default Radio
